import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram } from "react-icons/fa";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* BRAND */}
        <div className="footer-col footer-brand">
          <h3 className="footer-logo">
            Tabl<span>ify</span>
          </h3>

          <p>Modern digitális menü megoldásokkal erősítjük az éttermeket.</p>

          <div className="footer-social">
            <a href="https://www.facebook.com/profile.php?id=61589092657778">
              <FaFacebookF />
            </a>

            <a href="https://www.instagram.com/tablify.hu/">
              <FaInstagram />
            </a>
          </div>
        </div>

        {/* PRODUCT */}

        <div className="footer-col">
          <h4>Termék</h4>
          <Link to="/#how">Hogyan működik?</Link>
          <Link to="/#features">Funkciók</Link>
          <Link to="/#pricing">Árazás</Link>

          <a
            href="https://teszt-etterem.tablify.hu"
            target="_blank"
            rel="noreferrer"
          >
            Demó
          </a>
        </div>

        {/* COMPANY */}

        <div className="footer-col">
          <h4>Cég</h4>

          <Link to="/about">Rólunk</Link>
          <Link to="/contact">Kapcsolat</Link>
        </div>

        {/* LEGAL */}

        <div className="footer-col">
          <h4>Jogi</h4>

          <Link to="/privacy">Adatvédelem</Link>
          <Link to="/terms">Felhasználási feltételek</Link>
        </div>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Tablify. Minden jog fenntartva.
      </div>
    </footer>
  );
}

export default Footer;
